import "./web.set-timeout-72b6430f.js";
var d = function(u, r) {
  r === void 0 && (r = 300);
  var n;
  return function() {
    for (var i = this, e = arguments.length, o = new Array(e), t = 0; t < e; t++)
      o[t] = arguments[t];
    clearTimeout(n), n = setTimeout(function() {
      return u.apply(i, o);
    }, r);
  };
};
export {
  d
};
